import * as devisConf from '@/configuration/devisConf';

export default function getLigneAPlat(lignes) {
  let allLignes = [];
  lignes.forEach((ligne) => {
    if (ligne.type === devisConf.NORMAL) {
      allLignes.push(ligne);
    }
    if (ligne.type === devisConf.REGROUPEMENT) {
      allLignes = allLignes.concat(
        ligne.lignesCommande.filter((ligneEnfant) => {
          return ligneEnfant.type === devisConf.NORMAL;
        }),
      );
    }
  });
  return allLignes;
}

export function getLigneAPlatWithRegroupement(lignes) {
  if (!Array.isArray(lignes)) return [];
  return lignes
    .filter(l => [devisConf.REGROUPEMENT, devisConf.NORMAL].includes(l.type))
    .map(l => {
      if (l.type === devisConf.REGROUPEMENT) {
        return [l, l.lignesCommande];
      }
      return l;
    })
    .flat(2);
}
